import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 -5 240 51"

const HalfCircleIcon = createSvgIcon(
  <>
    <path d='M120,0c82.1,0,100.6,39.2,120,39.2c0,0.7,0,3.6,0,6.7c-23.6,0-194.8,0-240,0c0-2.7,0-4.1,0-6.7C14,39.2,37.9,0,120,0z' />
  </>,
  'HalfCircleIcon'
)

export default HalfCircleIcon
